import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetDailyReportListPagingAndFilterRequest, initialGetDailyReportListPagingAndFilterRequest } from '../../../models/request/report/GetDailyReportListPagingAndFilterRequest';
import { ReportService } from '../../../services/ReportService';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import DailyReportListFilters from './Components/DailyReportListFilters';
import { DeviceService } from '../../../services/DeviceService';
import { GetDailyReportListPagingAndFilterResponse, GetDailyReportListPagingAndFilterResponseData, GetDailyReportListPagingAndFilterResponseItem, initialGetDailyReportListPagingAndFilterResponseData } from '../../../models/response/report/GetDailyReportListPagingAndFilterResponse';
import { ExportDailyReportListResponse } from '../../../models/response/report/ExportDailyReportListResponse';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const DailyReportList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Raporlar > Günlük Rapor"
    const pageVersion = "3";
    const [data, setData] = useState<GetDailyReportListPagingAndFilterResponseData>(initialGetDailyReportListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetDailyReportListPagingAndFilterRequest>(initialGetDailyReportListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Tarih', name: 'gpsDateTime', order: 0, isVisible: true },
            { title: 'Kontak', name: 'ioStatusStr', order: 0, isVisible: true },
            { title: 'Hız', name: 'kmPerHour', order: 0, isVisible: true },
            { title: 'Toplam KM', name: 'currentKm', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Konum', name: 'location', order: 0, isVisible: true },
            { title: 'Enlem', name: 'latitude', order: 0, isVisible: true },
            { title: 'Boylam', name: 'longitude', order: 0, isVisible: true },
            // { title: 'Veri Tarihi', name: 'gpsDateTime', order: 0, isVisible: true },
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetDailyReportListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            if (Helpers.isEmpty(_filter.selectedDevice) || Helpers.isEmpty(_filter.startDateStr) || Helpers.isEmpty(_filter.endDateStr)) {
                toast.error('Lütfen boş alan bırakmayınız!')
                setData(initialGetDailyReportListPagingAndFilterResponseData);
                return;
            }

            dispatch(storeActivityIndicator(true))

            var response: GetDailyReportListPagingAndFilterResponse = await ReportService.getDailyReportListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportDailyReportListResponse = await ReportService.exportDailyReportList(buildExcelRequest(filter, mode, [], columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (DeviceDataHistoryManager.ApplyDailyReportColumnFilters) aynı. Enlem/boylam filtresiz.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        gpsDateTime: { type: 'date' },
        ioStatusStr: {
            type: 'select',
            allowEmpty: false,
            loadOptions: () => Promise.resolve([{ value: '1', label: 'Açık' }, { value: '0', label: 'Kapalı' }]),
            renderOption: (label) => <StatusBadge text={label} />
        },
        kmPerHour: { type: 'number' },
        currentKm: { type: 'number' },
        location: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetDailyReportListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == 'ioStatusStr')
            return <td className={className}><StatusBadge text={item.ioStatusStr} /></td>;

        var item2: any = item;
        return <td className={className}>{item2[column]}</td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <DailyReportListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    {/* Arama kutusu kaldırıldı (22.09.2026): raporda hiç çalışmıyordu; kolon
                        başlıklarının altındaki filtreler kullanılır. */}

                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th>{item.title}</th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={0}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr>
                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default DailyReportList;